export { RestrictedAccessGuard } from './RestrictedAccessGuard';
